import { useRequestProcessing } from '@gogame/query';

import {
  changeOwners,
  changeOwnersStatus,
} from 'scenes/Campaigns/sources/campaigns';

import { updateOwners } from '../queryKeyFactory';
import { messagesCampaigns } from '../messages';

export const useChangeOwners = () => {
  const updateMessage = messagesCampaigns.update();

  return useRequestProcessing(
    updateOwners(),
    changeOwners,
    changeOwnersStatus,
    {
      getCompletedMessage: () => updateMessage.completed(),
      getFailedMessage: () => updateMessage.failed(),
      getHasErrorsMessage: () => updateMessage.completedWithErrors(),
      getProcessMessage: (result) =>
        updateMessage.processing(result?.percentCompleted),
      getQueuedMessage: (result) =>
        updateMessage.queue(result?.percentCompleted),
    }
  );
};
